<template>
  <!-- 电气参数配置弹窗 -->
  <div class="electrical-parameters-dialog">
    <el-dialog v-model="dialogShowFlag" title="用电参数配置" width="80%">
      <!-- 表单，包含各项电气参数 -->
      <device-change v-model:form="form" :rules="rules" ref="deviceChangeRef"></device-change>
      <!-- 弹窗底部按钮 -->
      <template #footer>
        <el-button type="primary" :loading="loading" @click="submitForm">提交</el-button>
        <el-button @click="dialogShowFlag = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, defineExpose, inject, defineEmits } from "vue";
import { saveKanbanDataApi, getKanbanDataDetailApi } from "@/api/modules/project";
const receiveTemplateId = inject("templateId");
const receiveProjectModuleId = inject("projectModuleId"); // 默认值为21

import { ElMessage, ElLoading } from "element-plus";
import deviceChange from "../../device-change.vue";
const emit = defineEmits(["submit"]);
// 获取子组件实例
const deviceChangeRef = ref(null);
// 控制弹窗显示
const dialogShowFlag = ref(false);
// 提交按钮加载状态
const loading = ref(false);

// 表单初始值
const initialForm = {
  moduleId: receiveProjectModuleId.value,
  templateId: receiveTemplateId.value,
  detail: [
    {
      title: "用电量",
      detailId: 17,
      items: [
        {
          val: "",
          type: "1",
          unit: "",
          dictKey: "",
          dictName: "",
          name: "A",
          deviceIdStr: "",
          deviceName: "",
        },
      ],

      formula: "A",
    },
    {
      title: "功率",
      detailId: 82,
      items: [
        {
          val: "",
          type: "1",
          unit: "",
          dictKey: "",
          dictName: "",
          name: "A",
          deviceIdStr: "",
          deviceName: "",
        },
      ],

      formula: "A",
    },
    {
      title: "电压",
      detailId: 83,
      items: [
        {
          val: "",
          type: "1",
          unit: "",
          dictKey: "",
          dictName: "",
          name: "A",
          deviceIdStr: "",
          deviceName: "",
        },
      ],

      formula: "A",
    },
    {
      title: "电流",
      detailId: 84,
      items: [
        {
          val: "",
          type: "1",
          unit: "",
          dictKey: "",
          dictName: "",
          name: "A",
          deviceIdStr: "",
          deviceName: "",
        },
      ],

      formula: "A",
    },
    {
      title: "温度",
      detailId: 85,
      items: [
        {
          val: "",
          type: "1",
          unit: "",
          dictKey: "",
          dictName: "",
          name: "A",
          deviceIdStr: "",
          deviceName: "",
        },
      ],

      formula: "A",
    },
  ],
};

// 表单数据
const form = ref({ ...initialForm });

// 表单校验规则
const rules = {
  dictName: [{ required: false, message: "请选择设备", trigger: "blur" }],
};

// 重置表单
const resetForm = () => {
  Object.assign(form.value, initialForm);
  deviceChangeRef.value?.resetForm();
};

// 提交表单
const submitForm = () => {
  deviceChangeRef.value.validateForm().then((valid) => {
    if (valid) {
      loading.value = true;
      let formCopy = JSON.parse(JSON.stringify(form.value));
      formCopy.sewageStationInfo = {
        detail: formCopy.detail,
        blockId: 9,
      };

      delete formCopy.detail;

      saveKanbanDataApi(formCopy)
        .then((res) => {
          if (res.data.code == 200) {
            loading.value = false;
            dialogShowFlag.value = false;
            ElMessage({
              type: "success",
              message: "保存成功",
            });
            emit("submit");
            resetForm();
          } else {
            loading.value = false;
            ElMessage({
              type: "error",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          loading.value = false;
        });
    } else {
      ElMessage.error("指标项不能为空");
    }
  });
};

const getDetail = () => {
  const getDetailLoading = ElLoading.service({ lock: true, text: "Loading", background: "rgba(0, 0, 0, 0.7)" });

  let params = { moduleId: receiveProjectModuleId.value, templateId: receiveTemplateId.value, blockId: 9 };
  getKanbanDataDetailApi(params).then((res) => {
    if (res.data.code == 200) {
      getDetailLoading.close();
      dialogShowFlag.value = true;
      if (!res.data.data.sewageStationInfo.detail[0].items) return;
      form.value.detail = res.data.data.sewageStationInfo.detail;
    }
  });
};
// 打开弹窗方法，供外部调用
const openDialog = () => {
  getDetail();
};
defineExpose({ openDialog });
</script>

<style lang="scss" scoped>
.contentItem {
  width: calc(100% - 60px);
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  background: #f6f8fc;
  border: 1px solid #ebedfd;
  padding: 10px;
  margin-left: 20px;

  .liItemBox {
    width: 160px;
    height: 100px;
    background: #ffffff;
    padding: 16px;
    margin: 10px 36px 10px 26px;

    .bgc {
      min-width: 160px;
      width: 140px;
      height: 100%;
      background: rgba(22, 93, 255, 0.05);
      box-shadow: inset 0px 0px 20px 0px rgba(22, 93, 255, 0.1);
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 56px;
        height: 56px;
        margin-bottom: 8px;
      }

      > p:first-of-type {
        font-size: 16px;
      }

      > p:nth-of-type(2) {
        font-size: 12px;
        color: #409eff;
        cursor: pointer;
      }
    }
  }

  .el-radio-group {
    display: block;

    .el-radio {
      margin-right: 15px !important;
    }
  }

  > p,
  > div {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .contItemBox {
    align-items: center;
    margin: 10px 10px 10px 0;

    .symbol {
      margin-right: 10px;
      font-size: 20px;
      text-align: center;
      width: 16px;

      p {
        cursor: pointer;
        margin: 0;
      }

      .activeSymbol {
        color: #165dff;
        font-weight: bold;
      }
    }

    .symbol2 {
      margin-top: 50px;
    }
  }

  .addIcon,
  .delIcon {
    font-size: 17px;
    color: #000;
    cursor: pointer;
  }

  .addBox {
    width: 160px;
    height: 160px;
    border: 1px dashed #000;
    margin: 10px 0 0 10px;
    text-align: center;
    line-height: 160px;
    font-size: 40px;
    color: #000;
    cursor: pointer;
  }

  .contItem {
    display: flex;
    flex-direction: column;
    width: 160px;
    height: 100px;
    background: #ffffff;
    padding: 16px;
    position: relative;

    .delIcon {
      position: absolute;
      top: 8px;
      right: 6px;
      color: #5d5d5d;
      font-size: 18px;
      z-index: 1;
    }

    .el-select,
    .el-input {
      width: 160px;
      height: 30px;
      margin-right: 0;
    }

    .contTime .el-input {
      width: 110px;
      height: 30px;
    }

    .el-input__wrapper {
      height: 30px;
    }

    .contBox {
      position: relative;

      .el-select {
        margin-top: 20px;
      }
      .copy {
        position: absolute;
        left: -12px;
        top: -12px;
        width: 20;
        height: 20;
        cursor: pointer;
      }

      .center {
        span {
          color: #666666;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          background: rgba(51, 51, 51, 0.1);
          border-radius: 3px;
          margin-top: 10px;
          display: inline-block;
          padding: 3px 8px;
        }

        //.val .el-input__wrapper {
        //  box-shadow: 0 0 0 0;
        //  background-color: #f6f6f6;
        //}
        .val {
          margin-top: 30px;

          .el-input__wrapper {
            box-shadow: 0 0 0 0;
          }
        }

        .val .el-input__inner {
          font-size: 28px;
          color: #000;
        }

        .val .el-input__inner::placeholder {
          font-size: 12px;
          vertical-align: middle;
        }
      }

      .unit {
        text-align: right;
        position: absolute;
        top: 25px;
        right: 0;
      }
    }

    .contItem:hover .delIcon {
      display: block;
    }
  }

  .bagClass {
    .el-select__wrapper {
      width: 220px;
    }
  }
}
</style>
